export default __webpack_public_path__ + "static/media/misc-closetC-1024w.a01f6ebf.avif";